module.exports = __webpack_public_path__ + "a90ccdd05acf95bbfaa160e305e3fb23.svg";